import { Base } from "../Base";
export class Class extends Base {
    name;
    class = "lazy";
    _load;
    _base;
    get base() {
        return (this._base ??= this._load());
    }
    constructor(load, name) {
        super();
        this.name = name;
        this._load = load;
    }
    is(value) {
        return value === undefined || this.base.is(value);
    }
    prune(value) {
        return this.base.prune(value);
    }
    modify(type) {
        const result = super.modify(type);
        return Object.assign(result, {
            base: type?.base ?? this.base,
        });
    }
    static create(load, name) {
        return new Class(load, name);
    }
}
//# sourceMappingURL=Class.js.map